function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnlarge = function SvgEnlarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "-5 -10 84 84"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M77.632 23.044a3.21 3.21 0 0 1-.022 4.567L66.327 38.895c-2.992 2.992-7.537-1.553-4.545-4.545l5.818-5.818H51.573V57.46c0 4.232-6.428 4.232-6.428 0V-6.826c0-4.232 6.428-4.232 6.428 0v28.929h16.026l-5.818-5.819c-2.992-2.992 1.553-7.537 4.545-4.545zM28.431 57.46c0 4.232-6.428 4.232-6.428 0V28.531H5.976l5.818 5.819c2.992 2.992-1.553 7.537-4.545 4.545L-4.534 26.98a3.21 3.21 0 0 1 .478-3.936L7.249 11.739c2.992-2.992 7.538 1.553 4.545 4.545l-5.818 5.818h16.026V-6.826c0-4.232 6.428-4.232 6.428 0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    transform: "translate(.213 6.683)"
  }));
};
export default SvgEnlarge;